import { IActionResponse } from "../../services/proxies";
import { EnvironmentType } from "../utils/settings";

export async function CustomProcessResponseAsync(response: Promise<IActionResponse>) {
    //Add custom Processes
}

export function CustomProcessResponse(response: IActionResponse) {
    //Add custom Processes
}

export interface IServiceSettings {
    hostUrl: string;
    timeoutIntervalInMilliSeconds: number;
    applicationUrl: string;
}

const localServiceSettings: IServiceSettings = {
    hostUrl: "https://localhost",
    timeoutIntervalInMilliSeconds: 1000,
    applicationUrl: "http://localhost:3000",
};

const devServiceSettings: IServiceSettings = {
    hostUrl: "https://template.dev.vfx.local/svc",
    timeoutIntervalInMilliSeconds: 1000,
    applicationUrl: "https://template.dev.vfx.local",
};

const qaServiceSettings: IServiceSettings = {
    hostUrl: "https://here-now-qa.vinformatix.com/svc",
    timeoutIntervalInMilliSeconds: 1000,
    applicationUrl: "https://here-now-qa.vinformatix.com",
};

const sandboxServiceSettings: IServiceSettings = {
    hostUrl: "https://here-now-sandbox.vinformatix.com/svc",
    timeoutIntervalInMilliSeconds: 1000,
    applicationUrl: "https://here-now-sandbox.vinformatix.com",
};

const stagingServiceSettings: IServiceSettings = {
    hostUrl: "https://here-now-staging.vinformatix.com/svc",
    timeoutIntervalInMilliSeconds: 1000,
    applicationUrl: "https://here-now-staging.vinformatix.com",
};

const demoServiceSettings: IServiceSettings = {
    hostUrl: "https://here-now-demo.vinformatix.com/svc",
    timeoutIntervalInMilliSeconds: 1000,
    applicationUrl: "https://here-now-demo.vinformatix.com",
};

const prodServiceSettings: IServiceSettings = {
    hostUrl: "https://here-now.vinformatix.com/api",
    timeoutIntervalInMilliSeconds: 1000,
    applicationUrl: "https://here-now.vinformatix.com",
};

export const GetServiceSettings = (environment: EnvironmentType): IServiceSettings => {
    switch (environment) {
        case EnvironmentType.local: {
            return localServiceSettings;
        }
        case EnvironmentType.dev: {
            return devServiceSettings;
        }
        case EnvironmentType.qa: {
            return qaServiceSettings;
        }
        case EnvironmentType.sandbox: {
            return sandboxServiceSettings;
        }
        case EnvironmentType.staging: {
            return stagingServiceSettings;
        }
        case EnvironmentType.demo: {
            return demoServiceSettings;
        }
        case EnvironmentType.prod: {
            return prodServiceSettings;
        }
    }
}